import { baseApi } from "../../../api/baseApi.js";
import { prepareQueryParams, toFormData } from "../../../helpers/index.js";

export const checkoutApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    createPendingOrder: build.mutation({
      query: (payload) => {
        return {
          url: "/order",
          method: "POST",
          body: toFormData({ ...payload, ...prepareQueryParams() }),
        };
      },
      invalidatesTags: ["Checkout"],
    }),
    checkout: build.mutation({
      query: (payload) => {
        return {
          url: "/checkout",
          method: "POST",
          body: toFormData({ ...payload, ...prepareQueryParams() }),
        };
      },
      invalidatesTags: ["Checkout", "Cart"],
    }),
  }),
});

export const { useCreatePendingOrderMutation, useCheckoutMutation } =
  checkoutApi;
